import { type FC, type MouseEventHandler } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, LoadingButton } from 'base-ui'

interface LoginRegistrationRegistrationFormButtonsProps {
  isMutating: boolean
  onClose: MouseEventHandler
  submitButtonDisabled: boolean
}

export const LoginRegistrationRegistrationFormButtons: FC<
  LoginRegistrationRegistrationFormButtonsProps
> = ({ isMutating, onClose, submitButtonDisabled }) => {
  return (
    <div className="flex flex-col gap-2 tablet:flex-row">
      <LoadingButton
        className="basis-2/3 tablet:order-last"
        data-qa-id="register-form-submit-button"
        disabled={submitButtonDisabled || isMutating}
        id="register-submit-btn"
        loading={isMutating}
        loadingPosition="end"
        size="large"
        type="submit"
      >
        <FormattedMessage id="general.button.label.createAccount" />
      </LoadingButton>
      <Button
        className="tablet:basis-1/3"
        color="secondary"
        data-qa-id="register-form-back-button"
        id="register-back-btn"
        onClick={onClose}
      >
        <FormattedMessage id="general.link.label.back" />
      </Button>
    </div>
  )
}
